const ON_CHANGE_DEBOUNCE_TIMER = 300;
const RECENTLY_VIEWED_KEY = "recently-viewed"; // Recently viewed
var idkmsVariantId = 33617173905496;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update", // Shopping cart update
  quantityUpdate: "quantity-update", // Product quantity update on the product page
  variantChange: "variant-change", // Product Page Variant Changes
  cartError: "cart-error", // Shopping Cart Error
};

const webvista = (function () {
  // Private constant
  const SCROLL_LOCK_ATTR = "scroll-y-off";
  const FOCUS_VISIBLE_KEYS = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  const NO_DECIMAL_CURRENCIES = [
    "JPY",
    "KRW",
    "VND",
    "IDR",
    "CLP",
    "COP",
    "PYG",
    "UGX",
    "ISK",
    "HUF",
    "RWF",
    "BIF",
    "DJF",
    "GNF",
    "KMF",
    "XAF",
    "XOF",
    "XPF",
  ];

  // Private variables
  const trapFocusHandlers = {};
  let currentFocusedElement = null;
  let mouseClick = true; // It is assumed by default that the interaction is via mouse, avoiding the application of styles upon initial focus.
  let subscribers = {};

  // Private method
  function focusVisiblePolyfill() {
    window.addEventListener("keydown", (event) => {
      if (FOCUS_VISIBLE_KEYS.includes(event.code.toUpperCase())) {
        mouseClick = false;
      }
    });

    window.addEventListener("mousedown", () => {
      mouseClick = true;
    });

    window.addEventListener(
      "focus",
      () => {
        if (currentFocusedElement && currentFocusedElement.classList) {
          currentFocusedElement.classList.remove("focused");
        }
        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        if (currentFocusedElement && currentFocusedElement.classList) {
          currentFocusedElement.classList.add("focused");
        }
      },
      true,
    );
  }

  function loadingImage(image) {
    if (image.hasAttribute("data-srcset")) {
      image.setAttribute("srcset", image.dataset.srcset);
      image.removeAttribute("data-srcset");
      image.onload = () => image.classList.add("image-lazy-loaded");
    } else if (!image.onload) {
      image.classList.add("image-lazy-loaded");
    }
  }

  function moveTooltip(event, tooltip) {
    tooltip.style.left = `${event.clientX}px`;
    tooltip.style.top = `${event.clientY - 16}px`;
  }

  /* ====== Calculate the visible proportion of the element. ====== */
  function percentageSeen(element) {
    const viewportHeight = window.innerHeight;
    const scrollY = window.scrollY;
    const elemTop = element.getBoundingClientRect().top + scrollY;
    const elemHeight = element.offsetHeight;

    if (elemTop > scrollY + viewportHeight) return 0;
    if (elemTop + elemHeight < scrollY) return 100;

    const distance = scrollY + viewportHeight - elemTop;
    return (distance / ((viewportHeight + elemHeight) / 100)).toFixed(2);
  }

  /* ====== Generate a random number within a specified range. ====== */
  function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
  }

  return {
    /* ====== Debounce function ====== */
    debounce: function (fn, wait) {
      let timeoutId;
      return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(this, args), wait);
      };
    },
    /* ====== Throttling function ====== */
    throttle: function (fn, delay) {
      let lastCallTime = 0;
      return function (...args) {
        const now = Date.now();
        if (now - lastCallTime < delay) return;
        lastCallTime = now;
        return fn.apply(this, args);
      };
    },
    /* ====== Subscribe to events ====== */
    subscribe: function (eventName, callback) {
      if (subscribers[eventName] === undefined) {
        subscribers[eventName] = [];
      }
      subscribers[eventName] = [...subscribers[eventName], callback];
      return () => {
        subscribers[eventName] = subscribers[eventName].filter(
          (cb) => cb !== callback,
        );
      };
    },
    /* ====== Publish event ====== */
    publish: function (eventName, data) {
      if (subscribers[eventName]) {
        subscribers[eventName].forEach((callback) => {
          callback(data);
        });
      }
    },
    /* ====== Get fetch configuration ====== */
    fetchConfig: function (type = "json", method = "POST") {
      return {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Accept: `application/${type}`,
        },
      };
    },
    /* ====== Content Request ====== */
    fetchHtml: async function (url, signal = null) {
      const fetchOptions = signal ? { signal } : {};
      const response = await fetch(url, fetchOptions);
      if (!response.ok) {
        throw new Error(
          `HTTP error! Status: ${response.status} ${response.statusText}`,
        );
      }
      const text = await response.text();
      return new DOMParser().parseFromString(text, "text/html");
    },
    /* ====== Determine whether it is a number ====== */
    isNumeric: function (value) {
      if (typeof value === "number" && !isNaN(value)) return true;
      if (typeof value === "string" && value.trim() !== "") {
        return !isNaN(Number(value));
      }
      return false;
    },
    /* ====== Convert to a number; return the fallback value if it fails. ====== */
    toNumber: function (value, fallback = 0) {
      const n = typeof value === "number" ? value : Number(value);
      return Number.isFinite(n) ? n : fallback;
    },
    clampNumber: function (value, min, max) {
      return Math.min(Math.max(value, min), max);
    },
    /* ====== Format currency amounts ====== */
    formatPriceAmount: function (amount = 0, currency) {
      if (!window["priceFormatTemplate"] || !currency) return;
      const value = amount / 100;
      const hasNoDecimals = NO_DECIMAL_CURRENCIES.includes(currency);
      const locale = currency === "EUR" ? "de-DE" : undefined;
      const price = value.toLocaleString(locale, {
        minimumFractionDigits: hasNoDecimals ? 0 : 2,
        maximumFractionDigits: hasNoDecimals ? 0 : 2,
      });
      return window["priceFormatTemplate"].replace(/0([,.]0{0,2})?/, price);
    },
    /* ====== Round down to the nearest multiple ====== */
    floorToMultiple: function (n, x) {
      return Math.floor(n / x) * x;
    },
    /* ====== Round up to the nearest specified multiple ====== */
    ceilToMultiple: function (n, x) {
      return Math.ceil(n / x) * x;
    },
    /* ====== Disable page scrolling :: Simulate page scroll position ====== */
    disablePageScroll: function () {
      // Determine whether it has been disabled.
      if (document.body.hasAttribute(SCROLL_LOCK_ATTR)) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      document.body.style.top = -scrollTop + "px";
      document.body.setAttribute(SCROLL_LOCK_ATTR, "true");
    },
    /* ====== Re-enable page scrolling :: Assumes page scrolling was disabled by disablePageScroll ====== */
    enablePageScroll: function () {
      if (!document.body.hasAttribute(SCROLL_LOCK_ATTR)) return;
      const scrollPosition = -parseInt(document.body.style.top, 10);
      document.body.style.top = null;
      document.body.removeAttribute(SCROLL_LOCK_ATTR);
      requestAnimationFrame(() => window.scrollTo(0, scrollPosition));
    },
    /* ====== Get focusable elements ====== */
    getFocusableElements: function (container, filter_invisible = true) {
      let list = Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
        ),
      );
      if (filter_invisible) {
        list = list.filter((element) => element.offsetParent !== null);
      }
      return list;
    },
    /* ====== Set up a focus trap ====== */
    trapFocus: function (container, elementToFocus) {
      if (!container) return;
      const trap = container.hasAttribute("data-trap") ? container : container.querySelector("[data-trap]");
      if (!trap) return;

      const elements = this.getFocusableElements(trap);
      if (elements.length <= 0) return;

      const first = elements[0];
      const last = elements[elements.length - 1];
      elementToFocus = elementToFocus || trap;

      this.removeTrapFocus();

      trapFocusHandlers.focusin = (event) => {
        if (event.target !== trap && event.target !== last && event.target !== first) return;
        document.addEventListener("keydown", trapFocusHandlers.keydown);
      };

      trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
      };

      trapFocusHandlers.keydown = function (event) {
        if (event.code && event.code.toUpperCase() !== "TAB") return;

        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        } else if ((event.target === trap || event.target === first) && event.shiftKey) {
          event.preventDefault();
          last.focus();
        }
      };

      document.addEventListener("focusin", trapFocusHandlers.focusin);
      document.addEventListener("focusout", trapFocusHandlers.focusout);
      elementToFocus.focus();

      if (
        elementToFocus.tagName === "INPUT" &&
        ["search", "text", "email", "url"].includes(elementToFocus.type) &&
        elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(
          elementToFocus.value.length,
          elementToFocus.value.length,
        );
      }
    },
    /* ====== Remove focus trap ====== */
    removeTrapFocus: function (elementToFocus = null) {
      document.removeEventListener("focusin", trapFocusHandlers.focusin);
      document.removeEventListener("focusout", trapFocusHandlers.focusout);
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
      if (!elementToFocus) return;

      if (elementToFocus.closest("[data-trap]")) {
        this.trapFocus(elementToFocus.closest("[data-trap]"), elementToFocus);
      } else {
        elementToFocus.focus();
      }
    },
    /* ====== Initialize the focus-visible polyfill. ====== */
    initFocusVisible: function () {
      try {
        document.querySelector(":focus-visible");
      } catch (e) {
        focusVisiblePolyfill();
      }
    },
    /* ====== Stop all video playback ====== */
    pauseAllMedia: function (dom = document) {
      dom.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*",
        );
      });
      dom.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
      });
      dom.querySelectorAll("video").forEach((video) => video.pause());
      dom.querySelectorAll("product-model").forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    },
    /* ======= Play all videos ======= */
    playAllMedia: function (dom = document) {
      dom.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          "*",
        );
      });
      dom.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"play"}', "*");
      });
      dom.querySelectorAll("video").forEach((video) => video.pause() );
    },
    /* ======= Listen for the ESC key to close Details. ======= */
    onKeyUpEscape: function (event) {
      if (event.code && event.code.toUpperCase() !== "ESCAPE") return;

      const openDetailsElement = event.target.closest("details[open]");
      if (!openDetailsElement) return;

      const summaryElement = openDetailsElement.querySelector("summary");
      openDetailsElement.removeAttribute("open");
      summaryElement.setAttribute("aria-expanded", "false");
      summaryElement.focus();
    },
    /* ====== Set Cookie ====== */
    setCookie: function (name, value, hoursToExpire = 30) {
      const date = new Date();
      date.setTime(date.getTime() + hoursToExpire * 60 * 60 * 1000);
      document.cookie = `${name}=${encodeURIComponent(value)};expires=${date.toUTCString()};path=/`;
    },
    /* ====== Get cookie value ====== */
    getCookie: function (name) {
      const nameEQ = name + "=";
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while (cookie.charAt(0) === " ") {
          cookie = cookie.substring(1);
        }
        if (cookie.indexOf(nameEQ) === 0) {
          return decodeURIComponent(cookie.substring(nameEQ.length));
        }
      }
      return null;
    },
    /* ====== Store data in LocalStorage ====== */
    storeData: function (key, value, expirationInMinutes = null) {
      const dataToStore = {
        value: value,
        expiration: expirationInMinutes ? Date.now() + expirationInMinutes * 60000 : null,
      };
      localStorage.setItem(key, JSON.stringify(dataToStore));
    },
    /* ====== Read data from LocalStorage ====== */
    retrieveData: function (key) {
      try {
        const data = localStorage.getItem(key);
        if (!data) return null;

        const dataObj = JSON.parse(data);
        if (!dataObj) return null;

        if (dataObj.expiration === null || Date.now() < dataObj.expiration) {
          return dataObj.value;
        }
        localStorage.removeItem(key);
        return null;
      } catch (e) {
        return null;
      }
    },
    /* ====== Asynchronous wait ====== */
    sleep: function (ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    /* ====== Zero-padding ====== */
    padNumber: function (num, length) {
      return String(num).padStart(length, "0");
    },
    /* ====== Normalized string ====== */
    normalizeString: function (str) {
      return str
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "")
        .toLowerCase();
    },
    /* ====== Detect mobile screen ====== */
    isMobileScreen: function () {
      return window.matchMedia("(max-width: 749px)").matches;
    },
    /* ====== Detect tablet screen ====== */
    isPadScreen: function () {
      return window.matchMedia("(max-width: 999px)").matches;
    },
    /* ====== Check for RTL layout ====== */
    isRTL: function () {
      return getComputedStyle(document.documentElement).direction === "rtl";
    },
    /* ====== Initialize image lazy loading ====== */
    initLazyImages: function () {
      if (!window["enableLazyImage"]) return;

      const observe = () => {
        const lazyImages = document.querySelectorAll(".image-lazy-loading:not(.image-lazy-loaded)");
        if ("IntersectionObserver" in window) {
          const observer = new IntersectionObserver(
            (entries, observer) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  loadingImage(entry.target);
                  observer.unobserve(entry.target);
                }
              });
            },
            { rootMargin: "0px 0px 400px 0px" },
          );
          lazyImages.forEach((img) => observer.observe(img));
        } else {
          lazyImages.forEach(loadingImage);
        }
      };
      // Wait for layout to complete before observing
      requestAnimationFrame(() => requestAnimationFrame(observe));
    },
    /* ====== Initialize ToolTip ====== */
    initTooltips: function () {
      if (this.isMobileScreen()) return;

      const triggers = document.querySelectorAll('[data-toggle="tooltip"]:not([data-tooltip-loaded])');
      const loadTooltip = (trigger) => {
        trigger.addEventListener("mouseenter", () => {
          // First, delete the previous tooltip.
          document.querySelectorAll(".tool-tip").forEach((element) => element.remove());
          // New
          const tooltip = document.createElement("div");
          tooltip.className = "tool-tip";
          tooltip.textContent = trigger.getAttribute("data-title");
          document.body.appendChild(tooltip);

          const onMouseMove = (e) => moveTooltip(e, tooltip);
          const hide = () => {
            tooltip.remove();
            trigger.removeEventListener("mousemove", onMouseMove);
          };

          trigger.addEventListener("mousemove", onMouseMove);
          trigger.addEventListener("mouseleave", hide, { once: true });
          window.addEventListener("scroll", hide, { once: true });
        });
        trigger.setAttribute("data-tooltip-loaded", "true");
      };

      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              loadTooltip(entry.target);
              observer.unobserve(entry.target);
            }
          });
        });
        triggers.forEach((t) => observer.observe(t));
      } else {
        triggers.forEach(loadTooltip);
      }
    },
    /* ====== Initialize scroll synchronization effect ====== */
    initScrollSynergy: function () {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || this.isMobileScreen()) return;

      const elements = Array.from(document.querySelectorAll(".scroll-synergy:not([data-scroll-synergy-observed])"));
      if (elements.length <= 0) return;

      const elementStates = new WeakMap();

      // Initialize element state
      elements.forEach((el) => {
        elementStates.set(el, { prePosition: null, isVisible: false });
      });

      const updateElement = (el) => {
        const percentage = percentageSeen(el);
        const state = elementStates.get(el);
        let position;

        if (percentage <= 0) {
          position = 0;
        } else if (percentage < 30) {
          position = 1;
        } else if (percentage < 100) {
          position = 2;
        } else {
          position = 3;
        }

        // The position has changed.
        if (state.prePosition !== position) {
          el.classList.remove("synergy-position--1", "synergy-position--2");
          if (position > 0 && position < 3) {
            el.classList.add(`synergy-position--${position}`);
          }
          state.prePosition = position;
        }
        el.style.setProperty("--synergy-ratio", `${percentage}%`);

        if (el.classList.contains("synergy--zoom-in")) {
          el.style.setProperty("--zoom-in-ratio", (1 + 0.005 * percentage).toString());
        } else if (el.classList.contains("synergy--parallax")) {
          el.style.setProperty("--parallax-ratio", (percentage / 100).toString());
        } else if (
          el.classList.contains("synergy--crab-left") ||
          el.classList.contains("synergy--crab-right")
        ) {
          let crabRatio = 0.25 * percentage;
          if (el.classList.contains("synergy--crab-left")) {
            crabRatio *= -1;
          }
          el.style.setProperty("--crab-ratio", `${crabRatio}%`);
        }
      };

      const handleScroll = this.throttle(() => {
        elements.forEach((el) => {
          const state = elementStates.get(el);
          if (state.isVisible) {
            updateElement(el);
          }
        });
      }, 20); // The throttling time can be adjusted according to requirements.

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const el = entry.target;
          const state = elementStates.get(el);
          state.isVisible = entry.isIntersecting;

          if (entry.isIntersecting) {
            // Add initial position information
            updateElement(el);
            el.setAttribute("data-init", "true");
          }
        });
      });

      elements.forEach((element) => {
        observer.observe(element);
        element.setAttribute("data-scroll-synergy-observed", "true");
      });
      window.addEventListener("scroll", handleScroll);
    },
    /* ====== Initialize header height ====== */
    initHeaderHeight: function () {
      const setHeaderHeight = () => {
        const header = document.querySelector("header");

        if (header) {
          const rect = header.getBoundingClientRect();
          document.documentElement.style.setProperty("--header-height", `${Math.floor(rect.height)}px`);
          document.documentElement.style.setProperty("--header-bottom", `${Math.floor(rect.bottom)}px`);
        }
      };
      setHeaderHeight(); // Initial run
      window.addEventListener("resize", setHeaderHeight); // Update on resize
    },
    /* ====== Display a toast notification. ====== */
    popToast: function (message = "", type = "info") {
      if (!message) return;

      const toast = document.createElement("div");
      toast.className = `toast type-${type}`;
      toast.setAttribute("aria-role", "alert");
      toast.setAttribute("aria-live", "assertive");
      toast.textContent = message;

      setTimeout(() => toast.remove(), 5000);

      const container = document.getElementById("toasts-container");
      if (container) container.appendChild(toast);
    },
    /* ====== Scroll to the position of the specified element. ====== */
    scrollToElementWithOffset: function (element, offset = 50) {
      if (!element) return;

      const elementTop = element.getBoundingClientRect().top + window.scrollY;
      const targetPosition = Math.max(0, elementTop - offset);

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    },
    /* ====== Scroll to the bottom of the header ====== */
    scrollElementToHeaderBottom: function (element, offset = 0) {
      const header = document.getElementById("Page-Header");
      if (!header || !element) return;

      const headerBottom = header.getBoundingClientRect().bottom;
      /* ==== Scroll to top on variant change ==== */
      this.scrollToElementWithOffset(
        element,
        Math.max(0, headerBottom) + offset,
      );
    },
    /* ====== Color processing-related ====== */
    hexToHSL: function (hex) {
      // Remove the # symbol and parse the RGB value.
      hex = hex.replace(/^#/, "");
      const r = parseInt(hex.slice(0, 2), 16) / 255;
      const g = parseInt(hex.slice(2, 4), 16) / 255;
      const b = parseInt(hex.slice(4, 6), 16) / 255;
      // Calculate the maximum, minimum, and difference.
      const max = Math.max(r, g, b);
      const min = Math.min(r, g, b);
      const d = max - min; // Fix: Explicitly define d
      let h = 0, s = 0, l = (max + min) / 2;

      // Calculate hue
      if (d !== 0) {
        switch (max) {
          case r:
            h = ((g - b) / d) % 6;
            break;
          case g:
            h = (b - r) / d + 2;
            break;
          case b:
            h = (r - g) / d + 4;
            break;
        }
        h = Math.round(h * 60);
        if (h < 0) h += 360;
      }
      // Calculate saturation.
      if (d !== 0) {
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        s = Math.round(s * 100);
      }
      // Lightness
      l = Math.round(l * 100);

      return { h, s, l };
    },
    HSLToHex: function (h, s, l) {
      // Normalized HSL values
      h /= 360;
      s /= 100;
      l /= 100;

      let r, g, b;

      if (s === 0) {
        r = g = b = l; // Grayscale
      } else {
        const hue2rgb = (p, q, t) => {
          if (t < 0) t += 1;
          if (t > 1) t -= 1;
          if (t < 1 / 6) return p + (q - p) * 6 * t;
          if (t < 1 / 2) return q;
          if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
          return p;
        };

        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;

        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
      }

      // Convert RGB components to HEX
      const toHex = (x) => {
        const hex = Math.round(x * 255).toString(16);
        return hex.length === 1 ? "0" + hex : hex;
      };
      return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase();
    },
    /* ====== Get interpolated intermediate color ====== */
    getIntermediateColor: function (color1, color2, rate) {
      const hsl1 = webvista.hexToHSL(color1);
      const hsl2 = webvista.hexToHSL(color2);
      const h = hsl1.h + (hsl2.h - hsl1.h) * rate;
      const s = hsl1.s + (hsl2.s - hsl1.s) * rate;
      const l = hsl1.l + (hsl2.l - hsl1.l) * rate;

      return webvista.HSLToHex(h, s, l);
    },
    /* ====== Initialization method ====== */
    init: function () {
      this.initHeaderHeight();
      this.initLazyImages();
      this.initTooltips();
      this.initScrollSynergy();
      this.initFocusVisible();

      if (window.Shopify.designMode || window.debug) {
        // In Design mode or Debug mode, add a listener for screen width breakpoint changes.
        const mediaQuery = window.matchMedia("(min-width: 750px)");
        const handleMediaChange = (event) => {
          // Enable on desktop
          if (event.matches) this.initScrollSynergy();
        };
        // Add listener
        mediaQuery.addEventListener("change", handleMediaChange);
      }
    },
  };
})();

// Automatic initialization
document.addEventListener("DOMContentLoaded", () => webvista.init());

/* ====== Shopify Common JS ====== */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value === option.value || value === option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

/* ====== Creates and submits a form to send a POST request.
 * Use this function to dynamically generate and submit a form for sending data to the server; it is suitable for scenarios where
 * a POST request cannot be sent directly via an <a> tag or JavaScript. ====== */
Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options["method"] || "post";
  const params = options["parameters"] || {};
  const form = document.createElement("form");

  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (let key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);

  if (options && options["hideElement"]) {
    this.provinceContainer = document.getElementById(options["hideElement"]);
  } else {
    this.provinceContainer = document.getElementById(province_domid);
  }

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );
  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    const value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function () {
    const value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function (e) {
    const opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute("data-provinces");
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length <= 0) {
      this.provinceContainer.style.display = "none";
    } else {
      provinces.forEach((province) => {
        const opt = document.createElement("option");
        opt.value = province[0];
        opt.innerHTML = province[1];
        this.provinceEl.appendChild(opt);
      });
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function (selector, values) {
    if (values.length && values.length > 0)
      values.forEach((value) => {
        const opt = document.createElement("option");
        opt.value = value;
        opt.innerHTML = value;
        selector.appendChild(opt);
      });
  },
};

/* ====== Class SectionDynamicUpdate Used to dynamically update the content of specific sections on the page. ====== */
class SectionDynamicUpdate {
  /* ====== Parses the provided HTML string and returns the inner HTML of the element matching the specified selector. ====== */
  static getSectionInnerHTML(html, id, selector) {
    const dom = new DOMParser().parseFromString(html, "text/html");
    if (!dom) return "";
    const element = dom.querySelector(selector) || dom;
    return element.innerHTML;
  }
  /* ====== Update the corresponding sections on the page based on the provided `sections` array and the response content. ====== */
  static updateSections(sections, responseSections) {
    sections.forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) ||
        document.getElementById(section.id);

      if (elementToReplace)
        elementToReplace.innerHTML = SectionDynamicUpdate.getSectionInnerHTML(
          responseSections[section.section],
          section.id,
          section.selector,
        );
    });

    webvista.initLazyImages();
    if (typeof initializeScrollAnimationTrigger === "function") {
      initializeScrollAnimationTrigger();
    }

    webvista.initTooltips();
  }
}

/* ====== Quantity Selector ====== */
class QuantityInput extends HTMLElement {
  quantityUpdateUnsubscriber = undefined;

  constructor() {
    super();
    this.changeEvent = new Event("change", { bubbles: true });
    this.input = this.querySelector("input"); // Input box
    this.input.addEventListener("change", this.onInputChange.bind(this));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );

    this.updateQtyButtonState();
    this.quantityUpdateUnsubscriber = webvista.subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.updateQtyButtonState.bind(this),
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) this.quantityUpdateUnsubscriber();
  }

  /* ====== Handle input field changes ====== */
  onInputChange(event) {
    this.updateQtyButtonState();
  }

  /* ====== Handle increment/decrement button clicks ====== */
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    // stepUp and stepDown do not trigger the input's change event, so it must be triggered manually.
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  /* ====== Adjust the `disabled` attribute of the quantity increment/decrement buttons. ====== */
  updateQtyButtonState() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity-button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity-button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}
customElements.define("quantity-input", QuantityInput);

class HeaderDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetails = this.querySelector("details");
    this.mainSummary = this.querySelector("summary");
    this.header = this.closest(".section-header");
    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    // The drawer opens.
    this.mainDetails.addEventListener("toggle", this.onToggleMain.bind(this));
    // Submenu
    const menuNav = this.querySelector(".menu-drawer-nav");
    menuNav.querySelectorAll("details").forEach((detail) => {
      detail.addEventListener("toggle", this.onToggleSub.bind(this));
    });
  }

  // Keyboard events
  onKeyUp(event) {
    if (event.code && event.code.toUpperCase() !== "ESCAPE") return;
    this.mainDetails.removeAttribute("open");
  }

  onToggleMain(event) {
    if (event.currentTarget.hasAttribute("open")) {
      this.openMenuDrawer();
    } else {
      this.closeMenuDrawer();
    }
  }

  onToggleSub(event) {
    if (event.currentTarget.hasAttribute("open")) {
      this.openSubmenu(event.currentTarget);
    } else {
      this.closeSubmenu(event.currentTarget);
    }
  }

  /* ====== Open the main menu ====== */
  openMenuDrawer() {
    setTimeout(() => {
      this.mainDetails.classList.add("menu-open");
    });
    this.mainSummary.setAttribute("aria-expanded", "true");
    if (this.header) this.header.classList.add("header--is-active");

    this.setTopPosition();
    if (window.Shopify.designMode) {
      window.addEventListener("resize", this.setTopPosition.bind(this));
    }
    webvista.disablePageScroll(); // Disable scrolling
  }

  /* ====== Close main menu ====== */
  closeMenuDrawer() {
    this.mainDetails.classList.remove("menu-open");
    this.mainSummary.setAttribute("aria-expanded", "false");
    if (this.header) this.header.classList.remove("header--is-active");

    // Close submenu
    this.mainDetails
      .querySelectorAll('details[open][data-belong="1"]')
      .forEach((elements) => {
        elements.removeAttribute("open");
      });
    webvista.enablePageScroll(); // Enable scrolling
    window.removeEventListener("resize", this.setTopPosition.bind(this));
  }

  // Lose focus, close menu
  onFocusOut(event) {
    const triggerElement = event.target;
    setTimeout(() => {
      if (
        this.mainDetails.hasAttribute("open") &&
        !this.mainDetails.contains(document.activeElement) &&
        !triggerElement.classList.contains("nav-button")
      ) {
        this.mainDetails.removeAttribute("open");
      }
    });
  }

  /* ====== Open submenu ====== */
  openSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".has-submenu"); // 父级菜单
    const summaryElement = detailsElement.querySelector("summary");
    summaryElement.setAttribute("aria-expanded", "true");

    // Delay the addition to prevent the animation from failing to apply to the element.
    setTimeout(() => {
      detailsElement.classList.add("menu-open");
    });

    if (parentMenuElement) {
      // Parent menu state, indicating an open submenu.
      parentMenuElement.classList.add("submenu-open");
      // Close sibling menu
      if (!webvista.isPadScreen()) {
        Array.from(parentMenuElement.querySelectorAll(`details[open][data-belong="${parentMenuElement.dataset.level}"]`))
          .filter((details) => details !== detailsElement)
          .forEach((details) => {
            details.removeAttribute("open");
          });
      }
    }
  }

  /* ====== Close submenu ====== */
  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    const summaryElement = detailsElement.querySelector("summary");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");

    detailsElement.classList.remove("menu-open");
    summaryElement.setAttribute("aria-expanded", "false");

    // Close submenu
    Array.from(detailsElement.querySelectorAll("details[open]"), (details) => {
      details.removeAttribute("open");
    });

    Array.from(detailsElement.querySelectorAll(".submenu-open"), (element) => {
      element.classList.remove("submenu-open");
    });
  }

  /* ====== Set the top position of the menu drawer. ====== */
  setTopPosition() {
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0; // Determine whether the header has a bottom border.

    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom",
        `${this.header.querySelector("header").getBoundingClientRect().bottom - this.borderOffset}px`,
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`,
    );
  }
}
customElements.define("header-drawer", HeaderDrawer);

/* ====== class ModalOpener :: A custom element, ModalOpener, used to open a specified modal dialog. ====== */
class ModalOpener extends HTMLElement {
  constructor() {
    super();

    if (this.hasAttribute("aria-disabled")) return;
    this.modal = document.getElementById(this.getAttribute("aria-controls"));
    if (!this.modal) return;

    // If the element does not have a `tabindex` set (in cases where there is a fallback link)
    if (!this.hasAttribute("tabindex")) {
      this.setAttribute("tabindex", "0");
      const link = this.querySelector("a.fallback-link"); // Only a maximum of one fallback link is allowed.
      if (link) link.setAttribute("tabindex", "-1"); // Avoid stealing the spotlight.
    }

    this.boundOnOpenerClick = this.onOpenerClick.bind(this);
    this.boundOnKeyDown = this.onKeyDown.bind(this);
    this.addEventListener("click", this.boundOnOpenerClick);
    this.addEventListener("keydown", this.boundOnKeyDown);
  }

  disconnectedCallback() {
    if (this.boundOnOpenerClick) this.removeEventListener("click", this.boundOnOpenerClick);
    if (this.boundOnKeyDown) this.removeEventListener("keydown", this.boundOnKeyDown);
  }

  onOpenerClick(event) {
    event.preventDefault(); // If the pop-up does not exist or JavaScript is not supported, the `<a>` tag serves as a fallback and is placed inside the component.
    if (this.getAttribute("aria-expanded") === "true") return;
    this.modal.show(this);
  }

  /* ====== Keyboard events ====== */
  onKeyDown(event) {
    if (["Space", "Enter"].includes(event.code)) {
      event.preventDefault(); // Prevent page scrolling
      this.modal.show(this);
    }
  }
}
customElements.define("modal-opener", ModalOpener);

/* ====== class ModalDialog :: A custom element, `ModalDialog`, used to show and hide a modal dialog. ====== */
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.hasOpened = false; // Open state
    // Allow page scrolling when the modal is open.
    this.enableScrollWhenOpen = this.hasAttribute("data-enable-scroll");

    // Closing via other methods is prohibited.
    if (!this.hasAttribute("data-force")) {
      this.addEventListener("keyup", (event) => {
        event.stopPropagation();
        if (event.code && event.code.toUpperCase() === "ESCAPE") this.hide();
      });

      this.addEventListener("click", (event) => {
        event.stopPropagation();
        // this.contains(event.target) Prevent nested usage
        if (this.contains(event.target) && event.target.classList.contains("modal-overlay")) this.hide();
      });
    }

    // Template Editing Mode
    if (window.Shopify.designMode) {
      document.addEventListener("shopify:section:select", (event) => {
        if (event.detail.sectionId === this.dataset.section) {
          this.show();
        } else {
          this.hide();
        }
      });

      document.addEventListener("shopify:section:deselect", (event) => {
        if (event.detail.sectionId === this.dataset.section) {
          this.hide();
        }
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    this.setAttribute("open", "");
    if (this.openedBy) this.openedBy.setAttribute("aria-expanded", "true");
    webvista.trapFocus(this);
    this.hasOpened = true;
    // if (!this.enableScrollWhenOpen) webvista.disablePageScroll(); (Regarding sudden reloading of the page)
  }

  hide() {
    this.removeAttribute("open");
    if (this.openedBy) {
      this.openedBy.setAttribute("aria-expanded", "false");
      webvista.removeTrapFocus(this.openedBy);
    }
    this.hasOpened = false;
    webvista.pauseAllMedia(this); // Stop all playing media
    // if (!this.enableScrollWhenOpen) webvista.enablePageScroll(); (Regarding sudden reloading of the page)
  }
}
customElements.define("modal-dialog", ModalDialog);

/* ====== Drawer-type items ====== */
class Drawer extends ModalDialog {
  constructor() {
    super();
  }
}
customElements.define("drawer-component", Drawer);

class TabPanel extends HTMLElement {
  constructor() {
    super();

    this.tabs = Array.from(this.querySelectorAll(".tab"));
    this.panels = Array.from(this.querySelectorAll(".panel"));
    if (!this.tabs || this.tabs.length < 2) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener("click", this.onTabClick.bind(this));
      tab.setAttribute("tabindex", 0);
      tab.addEventListener("keydown", this.onKeydown.bind(this));
    });
  }

  /* ====== Handle mouse clicks to switch tabs. ====== */
  onTabClick(event) {
    this.tabChoose(event.currentTarget);
  }

  /* ====== Handle keyboard switching Tab ====== */
  onKeydown(event) {
    const key = event.code ? event.code.toUpperCase() : "";
    if (key === "ENTER" || key === "SPACE") {
      this.tabChoose(event.currentTarget);
      event.preventDefault(); // Prevent the default scrolling behavior of the Space key.
    }
  }

  /* ====== Switch Tab ====== */
  tabChoose(tab) {
    const panel = document.getElementById(tab.getAttribute("aria-controls"));
    if (!tab || !panel) return;

    const currentTab = this.querySelector(".tab[aria-selected=true]");
    const currentPanel = this.querySelector(".panel:not([aria-hidden])");

    if (tab !== currentTab) {
      currentTab.setAttribute("aria-selected", "false");
      currentPanel.setAttribute("aria-hidden", "true");
      tab.setAttribute("aria-selected", true);
      panel.removeAttribute("aria-hidden");
    }

    this.scrollableContentViewer = this.scrollableContentViewer || tab.closest("scrollable-content-viewer");
    if (this.scrollableContentViewer) this.scrollableContentViewer.slideContentByItem(tab);
  }
}
customElements.define("tab-panel", TabPanel);

/* ====== DetailsDisclosure Class
 * This class creates a custom HTML element designed to manage the expansion and collapse behavior of <details> elements.
 * It primarily controls animations associated with <details> and <summary> elements and handles user interactions with them.
 * When the state of a <details> element changes (expanding or collapsing), it plays or cancels the content area's animation accordingly.
 * The class also provides a method to manually close the <details> element, ensuring accessibility and consistent state management. ====== */
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    this.content = this.mainDetailsToggle.querySelector("summary").nextElementSibling;
    if (!this.mainDetailsToggle || !this.content) return;

    this.observeVisibility();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  /* ====== Monitor element visibility :: Perform an action when visible ====== */
  observeVisibility() {
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // If expanded by default, initialize the height.
            this.handleWhenVisibility();
            observer.unobserve(this);
          }
        });
      },
      {
        root: null,
        threshold: 0.1,
      },
    );
    this.observer.observe(this);
  }

  /* ====== Execute when the element becomes visible. ====== */
  handleWhenVisibility() {
    if (this.mainDetailsToggle.hasAttribute("open")) this.onToggle();
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onToggle() {
    this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", this.mainDetailsToggle.hasAttribute("open"));
    // Asynchronous addition to prevent animation from failing to apply.
    setTimeout(() => {
      this.mainDetailsToggle.classList.toggle("has-opened", this.mainDetailsToggle.hasAttribute("open"));
    });
  }

  open() {
    this.mainDetailsToggle.setAttribute("open", "true");
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
  }
}
customElements.define("details-disclosure", DetailsDisclosure);

/* ====== DropMenu Class
 * This class extends DetailsDisclosure, providing functionality specific to drop-down menus and selectors.
 * In addition to managing the expand/collapse behavior inherited from the base class, it adds focus management capabilities.
 * The DropMenu class automatically closes the <details> element when the user moves focus away from it.
 * It supports opening on mouse hover.
 * It also automatically adjusts its width based on the size of a specified container to prevent overflow or clipping. ====== */
class DropMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.hoverCloseTimer = null;
  }

  handleWhenVisibility() {
    super.handleWhenVisibility();
    this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this));
    // Open on hover
    if (this.hasAttribute("data-hover-open")) {
      this.mainDetailsToggle.addEventListener("mouseenter", () => {
        if (this.hoverCloseTimer) {
          clearTimeout(this.hoverCloseTimer);
          this.hoverCloseTimer = null;
        }
        this.open();
      });
      this.mainDetailsToggle.addEventListener("mouseleave", () => {
        if (this.hoverCloseTimer) clearTimeout(this.hoverCloseTimer);
        this.hoverCloseTimer = setTimeout(this.close.bind(this), 300);
      });
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    // Adjust the position to prevent it from extending beyond the screen area.
    if (this.mainDetailsToggle.hasAttribute("data-constrain")) this.adjustContentPosition();
    // Toggle header active state
    const header = this.closest(".section-header");
    if (header) header.classList.toggle("header--is-active", this.mainDetailsToggle.hasAttribute("open"));

    super.onToggle();
  }

  /* ====== Adjusts the content position to ensure it does not exceed the [right-side] boundary.
   * Defaults to the viewport area.
   * Use `data-area` to specify a custom boundary area.
   * Use `data-adjust` to automatically adjust the position. ====== */
  adjustContentPosition() {
    const needAdjust = this.mainDetailsToggle.hasAttribute("data-adjust"); // Is automatic position adjustment required?

    if (!this.mainDetailsToggle.hasAttribute("open")) {
      this.mainDetailsToggle.classList.remove("position--exceed");
      // Automatically adjust position, reset position
      if (needAdjust) {
        this.content.style.left = null;
      }
    } else {
      // Adjust the position so that it does not exceed the restricted area.
      let areaRightSidePosition = document.documentElement.clientWidth; // Right boundary; defaults to the right side of the screen, excluding the scrollbar.
      let areaLeftSidePosition = 0; // Left boundary; defaults to the left side of the screen.
      if (this.dataset.area) {
        // If custom boundaries are set
        const areaRect = document.querySelector(this.dataset.area)?.getBoundingClientRect();
        if (areaRect) {
          areaRightSidePosition = areaRect.right;
          areaLeftSidePosition = areaRect.left;
        }
      }
      const contentRect = this.content.getBoundingClientRect();
      let offset = contentRect.right - areaRightSidePosition;  // Offset
      if (offset > 0) {
        // Outside the area
        this.mainDetailsToggle.classList.add("position--exceed");
        if (needAdjust) {
          this.content.style.left = `${-Math.ceil(offset)}px`;
        }
      }
    }
    this.mainDetailsToggle.classList.toggle("position--constrained", this.mainDetailsToggle.hasAttribute("open"));
  }
}
customElements.define("drop-menu", DropMenu);

/* ====== Delay media playback ====== */
class DeferredMedia extends HTMLElement {
  constructor() {
    super();

    this.template = this.querySelector("template");
    if (!this.template) return;

    // Click the button to load.
    const playButton = this.querySelector(".media-play-button");
    if (playButton) {
      playButton.removeAttribute("disabled");
      playButton.addEventListener("click", this.loadContent.bind(this));
    }

    // Mute button
    this.muteButton = this.querySelector(".mute-button");
    if (this.muteButton) this.muteButton.addEventListener("click", this.toggleMute.bind(this));

    // data-load-when-visible: Load video resources when the content becomes visible.
    if (this.hasAttribute("data-load-when-visible")) {
      this.initObserver();
    }
  }

  /* ====== Listen for the resource scrolling into the viewport :: Automatically play the video ====== */
  initObserver() {
    const options = {
      root: null,
      rootMargin: "100px 0px 100px 0px",
    };

    new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadContent();
          observer.disconnect();
        }
      });
    }, options).observe(this);
  }

  /* ====== Retrieve media resources ====== */
  loadContent(focus = true) {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.template.content.firstElementChild.cloneNode(true));
      this.deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      // Dispatch load-complete event
      this.dispatchEvent(
        new CustomEvent("deferred-loaded", {
          bubbles: true,
        }),
      );

      // Set the loading state during the next render to prevent page flickering caused by Firefox's automatic focusing.
      requestAnimationFrame(() => {
        this.setAttribute("loaded", "true");
      });

      if (this.deferredElement.nodeName === "VIDEO") {
        // Features a mute button and monitors volume changes.
        if (this.muteButton) {
          this.deferredElement.addEventListener("volumechange", this.onVolumeChange.bind(this));
          this.muteButton.setAttribute("aria-pressed", String(this.deferredElement.hasAttribute("muted"))); // Initialize the mute button state.
        }
        // Autoplay
        if (this.deferredElement.getAttribute("autoplay")) {
          this.deferredElement.play(); // Play video
        }
        // Playback completed
        this.deferredElement.addEventListener("ended", this.removeContent.bind(this));
      }
      if (focus) this.deferredElement.focus();
    }
  }

  /* ====== Remove the resource after playback completes. ====== */
  removeContent() {
    if (this.deferredElement) {
      this.deferredElement.remove();
      this.removeAttribute("loaded");
    }
  }
  /* ====== Handling volume changes ====== */
  onVolumeChange() {
    this.muteButton.setAttribute("aria-pressed", String(this.deferredElement.muted));
  }
  /* ====== Toggle mute status ======= */
  toggleMute() {
    if (this.deferredElement?.nodeName !== "VIDEO") return;

    this.deferredElement.muted = !this.deferredElement.muted;
    // Send a custom event
    this.dispatchEvent(
      new CustomEvent("video-mute", {
        bubbles: true,
        detail: {
          muted: this.deferredElement.muted,
        },
      }),
    );
  }
}
customElements.define("deferred-media", DeferredMedia);

/* ====== Variant attribute selector for a large number of variants :: Supports more than 250 variants ====== */
class HighVariantSelects extends HTMLElement {
  constructor() {
    super();

    this.productForm = document.getElementById(`product-form-${this.dataset.section}`);
    this.allVariantsData = this.parseJsonScript('[data-product-variants-json]');
    this.productOptionNames = this.parseJsonScript('[data-product-options-json]');
    this.variantSalePrices = this.parseJsonScript('[data-variant-sale-prices]');
    // Initialize currentVariant from server-rendered data on load
    this.getCurrentVariant();
    this.productForm?.addEventListener('submit', () => {
      if (this.currentVariant && typeof selectedVariant === "function") {
        selectedVariant(this.currentVariant);
      }
    }, true);
    this.addEventListener("change", this.onVariantChange.bind(this));
  }


  /* ====== Parse a JSON <script> tag inside this element by selector. ====== */
  parseJsonScript(selector) {
    const el = this.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* ====== Handling of Variant Changes ====== */
  onVariantChange(event) {
    // Guard against synchronous re-entrancy: updateVariantInput() dispatches a "change" event that bubbles back to this element's listener.
    if (this._isHandlingChange) return;
    this._isHandlingChange = true;
    try {
      this.toggleAddButtonStatus(true, "");
      this.removeErrorMessage(); // Remove error messages from product-form.
      this.updateOptions(event.target);
      /* ====== Re-sync Size sold-out hide/show for whichever option combination was just selected (e.g. Metal). ====== */
      this.updateSizeOptionAvailability();
      /* ====== Instant client-side update (no network wait) ====== */
      const instantVariant = this.applyInstantVariantUpdate();
      /* ====== Track whether the instant path already resolved a matching variant and painted the correct price. If it did, renderProductInfo() must
       * NOT overwrite the price block again once the fetch resolves — that redundant repaint was causing the ~600-800ms visible delay. ======= */
      this._priceAlreadyInstant = !!instantVariant;
      this.renderProductInfo(event.target);
    } finally {
      this._isHandlingChange = false;
    }
  }

  /* ====== Retrieves an array of IDs representing the selected value for each attribute of the selector.
   * Returns an array containing the collection of values. ====== */
  updateOptions(target) {
    if (target.tagName === "SELECT" && target.selectedOptions.length) {
      const previouslySelected = Array.from(target.options).find((option) => option.getAttribute("selected"));
      if (previouslySelected) previouslySelected.removeAttribute("selected");
      target.selectedOptions[0].setAttribute("selected", "selected");
    }
    this.optionValueIds = Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked"),
    ).map((element) => element.dataset.optionValueId);
  }

  /* ====== Instantly match the selected option values against product.variants and update price, media, URL, and buy button without waiting on fetch. ====== */
  applyInstantVariantUpdate() {
    if (!this.allVariantsData || !this.productOptionNames) return null;

    const selectedValues = this.getSelectedOptionValues();
    if (!selectedValues) return null;

    const matchedVariant = this.allVariantsData.find((variant) =>
      this.productOptionNames.every((_, i) => variant.options[i] === selectedValues[i])
    );

    if (!matchedVariant) return null;

    this.currentVariant = matchedVariant;

    webvista.publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        sectionId: this.dataset.section,
        html: null,
        variant: this.currentVariant,
      },
    });

    const targetJson = this.querySelector('script[data-selected-variant]');
    if (targetJson) targetJson.textContent = JSON.stringify(matchedVariant);

    this.updateVariantInput();
    this.updateURL();
    this.updateMedia();

    if (this.currentVariant) {
      this.updateMetalLabelInstant(this.currentVariant);
      this.updateShapeLabelInstant(this.currentVariant);
    }

    /* ====== Instant price update (no formatPriceAmount — reuse existing DOM structure) ====== */
    this.updatePriceInstant(matchedVariant);

    if (matchedVariant.available) {
      this.toggleAddButtonStatus(false);
    } else {
      this.toggleAddButtonStatus(true, window["variantStrings"]["soldOut"]);
    }

    const cta = document.getElementById('js-bespoke-select-setting');
    if (cta) {
      cta.dataset.shape = matchedVariant.option1;
      cta.dataset.variant = matchedVariant.id;
      cta.dataset.price = matchedVariant.price;
    }

    const reviewDesignCta = document.getElementById('js-bespoke-review-your-design');
    if (reviewDesignCta) {
      reviewDesignCta.dataset.shape = matchedVariant.option1;
      reviewDesignCta.dataset.variant = matchedVariant.id;
      reviewDesignCta.dataset.price = matchedVariant.price;
    }

    if (typeof selectedVariant === "function") selectedVariant(matchedVariant);

    return matchedVariant;
  }

  /* ====== Instantly update the metal/color swatch label without waiting for fetch The index into variant.options must come from this.productOptionNames
   * (== product.options — the same order Shopify uses for variant.options), NOT from the position of the fieldset in the DOM. Options that aren't
   * rendered as a <fieldset> (Design Detail, or an option hidden via a hide-<option>-option tag) get skipped when building the DOM fieldset
   * list, which shifts DOM-based indices out of sync with the real option order — that mismatch was the root cause of values like a Diamond Shape
   * ("Oval") showing up in the Metal label. ====== */
  updateMetalLabelInstant(variant) {
    if (!this.productOptionNames) return;

    const metalOptionIndex = this.productOptionNames.findIndex((name) =>
      /metal|color/i.test(name),
    );
    if (metalOptionIndex === -1) return;

    const fieldset = Array.from(
      this.querySelectorAll('fieldset.product-form-input'),
    ).find((el) => {
      const legend = el.querySelector('legend.form-label');
      return legend && /metal|color/i.test(legend.textContent);
    });
    if (!fieldset) return;

    const label = fieldset.querySelector('.selected-metal-label, .rc-selected-color-label');
    if (label) label.textContent = variant.options[metalOptionIndex] ?? '';
  }

  /* ====== Instantly update the diamond shape label without waiting for fetch
   * (see note on updateMetalLabelInstant re: why the index must come from this.productOptionNames rather than DOM fieldset position) ====== */
  updateShapeLabelInstant(variant) {
    if (!this.productOptionNames) return;

    const shapeOptionIndex = this.productOptionNames.findIndex((name) => /shape/i.test(name));
    if (shapeOptionIndex === -1) return;

    const fieldset = Array.from(
      this.querySelectorAll('fieldset.product-form-input'),
    ).find((el) => {
      const legend = el.querySelector('legend.form-label');
      return legend && /shape/i.test(legend.textContent);
    });
    if (!fieldset) return;

    const label = fieldset.querySelector('.rc-selected-shape-label');
    if (label) label.textContent = variant.options[shapeOptionIndex] ?? '';
  }

  /* ====== Reads the currently selected value for each product option, in product.options order, from selects or radios. ====== */
  getSelectedOptionValues() {
    const values = [];
    for (const optionName of this.productOptionNames) {
      const select = this.querySelector(`select[name="options[${optionName}]"]`);
      if (select) {
        values.push(select.value);
        continue;
      }
      const checked = this.querySelector(`fieldset input[type="radio"]:checked[name="${optionName}"]`);
      if (checked) {
        values.push(checked.value);
        continue;
      }

      /* ====== No input rendered for this option (e.g. hidden via hide-<option>-option tag, like "Diamond Coverage" on this product).
       * Fall back to the value from the currently tracked variant — with no UI control, this option's value never changes. ====== */
      const idx = this.productOptionNames.indexOf(optionName);
      if (this.currentVariant && this.currentVariant.options && idx !== -1) {
        values.push(this.currentVariant.options[idx]);
        continue;
      }
      return null; // unable to determine — fall back to fetch only
    }
    return values;
  }

  /* ====== Re-evaluate which Size options should be hidden as "sold out" for the CURRENTLY selected combination
   * of the other options (e.g. Metal). value.available in the server-rendered markup is only ever correct for
   * whichever variant was selected at the last full render — it's never recalculated for a client-side-only
   * change like switching Metal via the instant-update path, so the Size list would otherwise keep showing the
   * previous metal's hide/show state forever. IDKMS is exempt and never hidden here. ====== */
  updateSizeOptionAvailability() {
    const sizeDropdown = this.querySelector('.custom-dropdown[data-hide-sold-out-sizes="true"]');
    if (!sizeDropdown || !this.allVariantsData || !this.productOptionNames) return;

    const sizeIndex = this.productOptionNames.findIndex((name) => name.toLowerCase() === "size");
    if (sizeIndex === -1) return;

    const selectedValues = this.getSelectedOptionValues();
    if (!selectedValues) return;

    const isIdkms = (value) => (value || "").toLowerCase().indexOf("know my") !== -1;

    const isAvailableForCurrentSelection = (sizeValue) =>
      this.allVariantsData.some(
        (variant) =>
          variant.available &&
          variant.options[sizeIndex] === sizeValue &&
          this.productOptionNames.every((_, i) => i === sizeIndex || variant.options[i] === selectedValues[i]),
      );

      const buttons = Array.from(sizeDropdown.querySelectorAll(".custom-dropdown__option"));
      let selectedButton = null;
      let fallbackButton = null;
      let idkmsButton = null;

      buttons.forEach((button) => {
        const value = button.dataset.value;
        const idkms = isIdkms(value);
        const hide = !idkms && !isAvailableForCurrentSelection(value);
        button.classList.toggle("is-hide", hide);

        if (button.classList.contains("is-active")) selectedButton = button;
        if (idkms) {
          idkmsButton = button;
        } else if (!hide && !fallbackButton) {
          /* ====== Prefer the first in-stock numeric size — never let IDKMS win this by default. ====== */
          fallbackButton = button;
        }
      });

      /* ====== Only fall back to IDKMS if no real size is currently available at all. ====== */
      if (!fallbackButton) fallbackButton = idkmsButton;

  /* ====== If the selected size just became hidden, fall back to the first still-visible size
    * (IDKMS included) and drive the real selection through it — same path a user click would take. ====== */
  if (!selectedButton || !selectedButton.classList.contains("is-hide") || !fallbackButton) return;
    const fallbackValue = fallbackButton.dataset.value;
    const sizeOptionName = this.productOptionNames[sizeIndex];
    const sizeSelect = this.querySelector(`select[name="options[${sizeOptionName}]"]`);

    selectedButton.classList.remove("is-active");
    fallbackButton.classList.add("is-active");

    const label = sizeDropdown.querySelector(".custom-dropdown__label");
    if (label) label.textContent = fallbackValue;

    if (sizeSelect) {
      sizeSelect.value = fallbackValue;
      this.updateOptions(sizeSelect);
    }
  }

  /* ====== Instantly update price on variant change. ****
   * Targets the actual price.liquid DOM structure (no .money class exists).
   * Can update instantly (from variant JSON):  regular price, compare-at. Cannot update instantly (needs fetch): sale/VIP/VVIP amounts & %
   * Compromise: update the <s> strikethrough (= regular price) inside each sale bucket, leave actual sale amounts until syncPriceFromServerHtml runs. ====== */
  updatePriceInstant(variant) {
    const priceWrapper = document.getElementById(`Price-${this.dataset.section}`);
    if (!priceWrapper) return;

    const priceEl = priceWrapper.querySelector('.price');
    if (!priceEl) return;

    const regularWrap = priceEl.querySelector('[class*="regular-price-"]');
    if (!regularWrap) return;

    const idMatch = regularWrap.className.match(/regular-price-(\d+)/);
    if (!idMatch) return;

    const vid = idMatch[1];

    const fmt = (cents) => {
      if (!cents && cents !== 0) return null;
      const d = cents / 100;
      return '$' + (d % 1 === 0
        ? d.toLocaleString('en-US', { maximumFractionDigits: 0 })
        : d.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    };

    const compareWrap = priceEl.querySelector(`.compare-at-price-${vid}`);
    const saleWrap    = priceEl.querySelector(`.rc-sale-price-${vid}`);
    const vipWrap     = priceEl.querySelector(`.rc-vip-price-${vid}`);
    const vvipWrap    = priceEl.querySelector(`.rc-vvip-price-${vid}`);

    const regularPriceSpan = regularWrap.querySelector('.price-item--regular, .rc-main-regular-price');
    if (regularPriceSpan) {
      const fmtPrice = fmt(variant.price);
      if (fmtPrice) {
        /* ====== Shopify's money filter wraps output in <span class="money">$X</span> —
         * that's where the visible price text actually lives, not as a direct text-node child of this span. Update that first if present. ====== */
        const moneyEl = regularPriceSpan.querySelector('.money');
        if (moneyEl) {
          moneyEl.textContent = fmtPrice;
        } else {
          /* ====== Fallback: plain text-node child (preserves any nested "(Setting Only)" bespoke-ring label span if present) ====== */
          const textNode = [...regularPriceSpan.childNodes]
            .find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
          if (textNode) {
            textNode.textContent = fmtPrice;
          } else {
            regularPriceSpan.textContent = fmtPrice;
          }
        }
      }
    }

    if (compareWrap && variant.compare_at_price && variant.compare_at_price > variant.price) {
      const strikeEl    = compareWrap.querySelector('s');
      const mainPriceEl = compareWrap.querySelector('.rc-main-price');
      const discountEl  = compareWrap.querySelector('.price-discount');
      const pct = Math.round(
        (variant.compare_at_price - variant.price) / variant.compare_at_price * 100
      );
      if (strikeEl)    strikeEl.textContent    = fmt(variant.compare_at_price);
      if (mainPriceEl) mainPriceEl.textContent = fmt(variant.price);
      if (discountEl)  discountEl.textContent  = `${pct}% Off`;
    }

    /* ====== Sale / VIP / VVIP bucket text ====== */
    const salePricesData = this.variantSalePrices?.[String(variant.id)];

    if (salePricesData && (salePricesData.sale || salePricesData.vip || salePricesData.vvip)) {
      const saleAmt = salePricesData.sale  || 0;
      const vipAmt  = salePricesData.vip   || 0;
      const vvipAmt = salePricesData.vvip  || 0;

      const updateSaleBucket = (wrap, discountedPrice) => {
        if (!wrap) return;
        const s             = wrap.querySelector('s');
        const salePriceSpan = wrap.querySelector('.rc-sale-price');
        const discountEl    = wrap.querySelector('.price-discount');
        if (s) s.textContent = fmt(variant.price) || s.textContent;
        if (discountedPrice) {
          if (salePriceSpan) salePriceSpan.textContent = fmt(discountedPrice) ?? salePriceSpan.textContent;
          if (discountEl) {
            const pct = Math.round((variant.price - discountedPrice) / variant.price * 100);
            discountEl.textContent = `${pct}% Off`;
          }
        }
      };

      updateSaleBucket(saleWrap,  saleAmt);
      updateSaleBucket(vipWrap,   vipAmt);
      updateSaleBucket(vvipWrap,  vvipAmt);

      priceEl.dataset.regular = variant.price;
      priceEl.dataset.compare = variant.compare_at_price || 0;
      priceEl.dataset.sale    = saleAmt;
      priceEl.dataset.vip     = vipAmt;
      priceEl.dataset.vvip    = vvipAmt;

      /* ====== Only repaint THIS product's price block — not every .price on the page (that full-page sweep was the main source of the delay). ====== */
      if (typeof window.updateSinglePriceElement === 'function') {
        window.updateSinglePriceElement(priceEl);
      } else if (typeof window.initDynamicPrices === 'function') {
        window.initDynamicPrices();
      }
    } else {
      /* ====== Fallback: no sale/vip/vvip metafields on this variant. ====== */
      [saleWrap, vipWrap, vvipWrap].forEach(wrap => {
        if (!wrap) return;
        const s = wrap.querySelector('s');
        const fmtPrice = fmt(variant.price);
        if (s && fmtPrice) s.textContent = fmtPrice;
      });

      priceEl.dataset.regular = variant.price;
      priceEl.dataset.compare = variant.compare_at_price || 0;

      if (compareWrap && variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareWrap.classList.remove('is-hide');
        regularWrap.classList.add('is-hide');
        saleWrap?.classList.add('is-hide');
        vipWrap?.classList.add('is-hide');
        vvipWrap?.classList.add('is-hide');
      } else {
        compareWrap?.classList.add('is-hide');
        const anySpecialVisible =
          (saleWrap  && !saleWrap.classList.contains('is-hide'))  ||
          (vipWrap   && !vipWrap.classList.contains('is-hide'))   ||
          (vvipWrap  && !vvipWrap.classList.contains('is-hide'));
        if (!anySpecialVisible) regularWrap.classList.remove('is-hide');
      }
    }

    this.notifyEngravingPriceOnVariantChange();
  }

  /* ====== Sync the price block from server HTML after fetch completes —
   * without replacing DOM nodes, so is-hide visibility classes are preserved and initDynamicPrices() can apply the correct final state flash-free.
   * price.liquid embeds the variant ID in class names (regular-price-{id}, compare-at-price-{id}, etc.). When the variant changes, those IDs change
   * too, so we rename classes on the target elements to match the server. initDynamicPrices() reads customId from the class name — if we don't
   * rename, it looks for .compare-at-price-{newId} and finds nothing. ====== */
  syncPriceFromServerHtml(html) {
    /* ======  Outer wrapper: handle hidden state (e.g. unavailable variant) ====== */
    const srcWrapper = html.getElementById(`Price-${this.sourceSectionId}`);
    const tgtWrapper = document.getElementById(`Price-${this.dataset.section}`);
    if (!srcWrapper || !tgtWrapper) return;
    tgtWrapper.classList.toggle('hidden', srcWrapper.classList.contains('hidden'));

    const srcPrice = srcWrapper.querySelector('.price');
    const tgtPrice = tgtWrapper.querySelector('.price');
    if (!srcPrice || !tgtPrice) return;

    /* ====== Sync data attributes (regular, compare, sale, vip, vvip, id) :: initDynamicPrices reads these to decide which bucket to show. ====== */
    ['regular', 'compare', 'sale', 'vip', 'vvip', 'id'].forEach(key => {
      if (srcPrice.dataset[key] !== undefined) {
        tgtPrice.dataset[key] = srcPrice.dataset[key];
      }
    });

    /* ====== Resolve old (target) and new (source) variant IDs from class names. Must read tgtId from class name *before* we start renaming. ====== */
    const srcId    = srcPrice.dataset.id;
    const tgtMatch = tgtPrice.querySelector('[class*="regular-price-"]')?.className.match(/regular-price-(\d+)/);
    const tgtId = tgtMatch ? tgtMatch[1] : null;
    if (!srcId) return;

    /* ====== For each price bucket: copy innerHTML then rename class to new ID ***
     * Copying innerHTML updates formatted prices and % Off text. It does NOT touch the wrapper element's own classes (is-hide stays put).
     * Renaming the class ensures initDynamicPrices can find the element. ======= */
    [
      'regular-price',
      'compare-at-price',
      'rc-sale-price',
      'rc-vip-price',
      'rc-vvip-price',
    ].forEach(prefix => {
      const srcEl = srcPrice.querySelector(`.${prefix}-${srcId}`);
      const tgtEl = tgtId ? tgtPrice.querySelector(`.${prefix}-${tgtId}`) : null;
      if (!srcEl || !tgtEl) return;

      // Refresh text, percentage, and nested money values
      tgtEl.innerHTML = srcEl.innerHTML;

      // Rename class so initDynamicPrices finds this element by the new variant ID
      if (tgtId && srcId !== tgtId) {
        tgtEl.className = tgtEl.className.replace(
          `${prefix}-${tgtId}`,
          `${prefix}-${srcId}`,
        );
      }
    });
  }

  /* ====== Re-notify the engraving price snippet after a variant change so the engraving fee is re-applied on top of the new base price.
   * Only fires when the engraving toggle is currently ON. ====== */
  notifyEngravingPriceOnVariantChange() {
    if (typeof window.applyEngravingStonePriceOffset === "function") {
      window.applyEngravingStonePriceOffset();
    }
  }

  /* ====== Update current media display ====== */
  updateMedia() {
    if (!this.currentVariant?.featured_media?.id) return;
    // Set the currently displayed media.
    const mediaGallery = document.getElementById(`Media-Gallery-${this.dataset.section}`);
    if (mediaGallery) mediaGallery.updateGallery(this.currentVariant.featured_media.id);
  }

  /* ====== Update browser address ====== */
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;

    const params = new URLSearchParams(window.location.search);
    params.set("variant", this.currentVariant.id);

    // Preserve start-with-setting param across variant changes
    const startWithSetting = params.get("start-with-setting");
    const newParams = new URLSearchParams();
    newParams.set("variant", this.currentVariant.id);
    if (startWithSetting !== null) {
      newParams.set("start-with-setting", startWithSetting);
    }

    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?${newParams.toString()}`,
    );
  }

  /* ====== Update the form's variantId. ====== */
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      // Manually trigger the Change event.
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  /* ====== Set variant status to unsellable ====== */
  setUnavailable() {
    // Hide the specified element.
    const hidden_element_ids = [
      `Price-${this.dataset.section}`,
      `Inventory-${this.dataset.section}`,
      `Sku-${this.dataset.section}`,
      `Price-Per-Item-${this.dataset.section}`,
      `Volume-Note-${this.dataset.section}`,
      `Volume-${this.dataset.section}`,
      `Quantity-Rules-${this.dataset.section}`,
    ];
    hidden_element_ids.forEach((id) => {
      const element = document.getElementById(id);
      if (element) element.classList.add("hidden");
    });
  }

  /* ====== Remove error messages from product-form. ====== */
  removeErrorMessage() {
    if (!this.productForm) return;
    this.productForm.closest("product-form")?.handleErrorMessage();
  }

  /* ======= Updates product information
   * Includes price, inventory, SKU, quantity selector, purchase button area (Add to Cart, dynamic checkout, and back-in-stock notification buttons), 
   * sharing, free gifts, mini-checkout, and back-in-stock notification form. Broadcasts variant changes ====== */
  renderProductInfo(target) {
    this.abortController?.abort();
    this.abortController = new AbortController();

    webvista
      .fetchHtml(
        `${this.dataset.url}?option_values=${this.optionValueIds.join(",")}&section_id=${this.sourceSectionId}`,
        this.abortController.signal,
      )
      .then((html) => {
        const sourceJson = html.getElementById(`Variant-Selects-${this.sourceSectionId}`)?.querySelector('script[data-selected-variant]');
        const targetJson = this.querySelector('script[data-selected-variant]');
        if (sourceJson && targetJson) {
          targetJson.textContent = sourceJson.textContent;
        }
        this.getCurrentVariant();

        /* ====== Update metal/color and diamond shape labels from the already-resolved currentVariant
         * (no need to re-parse from HTML) — reuses the same index-safe helpers as the instant path (see updateMetalLabelInstant / updateShapeLabelInstant). ====== */
        if (this.currentVariant) {
          this.updateMetalLabelInstant(this.currentVariant);
          this.updateShapeLabelInstant(this.currentVariant);
        }

        if (!this.currentVariant) {
          this.toggleAddButtonStatus(true, window["variantStrings"]["unavailable"]);
          return this.setUnavailable();
        }

        // Only update things that NEED the server response
        const addCartButtonSource = html.getElementById(`Product-Submit-Button-${this.sourceSectionId}`);
        this.toggleAddButtonStatus(
          addCartButtonSource ? addCartButtonSource.hasAttribute("disabled") : true,
          addCartButtonSource ? addCartButtonSource.querySelector(".button-text").innerText : window["variantStrings"]["soldOut"],
        );

        /* ====== Skip the server price resync when the instant client-side update already resolved and painted this variant's price.
         * Running syncPriceFromServerHtml() again after the fetch resolves was causing a second, delayed repaint (~600-800ms) even though
         * the price was already correct — this was the visible "lag". ====== */
        if (!this._priceAlreadyInstant) {
          this.syncPriceFromServerHtml(html);
        }

        this.updateBlock(html, "Inventory", true, null, ({ innerHTML }) => innerHTML === "");
        this.updateBlock(html, "Sku", true, null, ({ innerHTML }) => innerHTML === "");
        this.updateBlock(html, "Share-Link");
        this.updateBlock(html, "Notify-Email-Button", false, null, ({ classList }) => classList.contains("hidden"));
        this.updateBlock(html, "Notify-Email");

        webvista.initLazyImages();
        webvista.initTooltips();

        webvista.publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: this.dataset.section,
            html,
            variant: this.currentVariant,
          },
        });
        selectedVariant(this.currentVariant);

        // Re-apply the engraving fee only after it has finished
        this.notifyEngravingPriceOnVariantChange();
      })
      .then(() => {
        document.querySelector(`#${target.id}`)?.focus();
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.log("Fetch aborted by user");
        } else {
          console.error(error);
        }
      });
  }

  /* ====== Update page section content ====== */
  updateBlock(
    html,
    blockId,
    replaceEntireBlock = true,
    selectorsToReplace,
    shouldHideCallback = (sourceElement) => false,
  ) {
    // Get the source and target elements.
    const sourceElement = html.getElementById(`${blockId}-${this.sourceSectionId}`);
    const targetElement = document.getElementById(`${blockId}-${this.dataset.section}`);
    // Return immediately if the element does not exist.
    if (!sourceElement || !targetElement) return;

    // If the source ID exists, the source ID within the content needs to be replaced with the target ID.
    if (this.dataset.originalSection) {
      // Create a clone of the source element to avoid modifying the original DOM.
      const clonedSource = sourceElement.cloneNode(true);
      // Replace the `this.dataset.originalSection` string in `sourceElement` with the `this.dataset.section` string.
      const htmlContent = clonedSource.innerHTML;
      const regex = new RegExp(this.dataset.originalSection, "g");
      clonedSource.innerHTML = htmlContent.replace(regex, this.dataset.section);
      // Use the processed clone element as the new source element.
      sourceElement.innerHTML = clonedSource.innerHTML;
    }

    // Content replacement logic
    if (replaceEntireBlock) {
      if (!selectorsToReplace?.length) {
        // Replace the entire block content
        targetElement.innerHTML = sourceElement.innerHTML;
      } else {
        // Replace the content of the specified selector.
        selectorsToReplace.forEach((selector) => {
          const targetSubElement = targetElement.querySelector(selector);
          const sourceSubElement = sourceElement.querySelector(selector);
          if (targetSubElement && sourceSubElement) {
            targetSubElement.replaceWith(sourceSubElement.cloneNode(true));
          }
        });
      }
    }
    // Update block visibility
    targetElement.classList.toggle("hidden", shouldHideCallback(sourceElement));
  }

  /* ====== Add to Cart button state ====== */
  toggleAddButtonStatus(disable = true, text) {
    if (!this.productForm) return;

    const addCartButtons = this.productForm.querySelectorAll('button[type="submit"]');
    const dynamicCheckout = this.productForm.querySelector(".dynamic-checkout"); // Dynamic Checkout

    if (disable) {
      addCartButtons.forEach((addButton) => {
        addButton.setAttribute("disabled", "disabled");
        if (!text) return;
        const addButtonTextElement = addButton.querySelector(".button-text");
        if (addButtonTextElement) addButtonTextElement.textContent = text;
      });
      // Hide dynamic payment
      if (dynamicCheckout && text) dynamicCheckout.classList.add("hidden");
    } else {
      addCartButtons.forEach((button) => {
        button.removeAttribute("disabled");
        const addButtonTextElement = button.querySelector(".button-text");
        if (!addButtonTextElement) return;

        addButtonTextElement.textContent = text ? text : window["variantStrings"]["addToCart"];
      });
      // Show dynamic checkout
      if (dynamicCheckout) dynamicCheckout.classList.remove("hidden");
    }
  }

  /* ====== Get the current variant JSON object. ====== */
  getCurrentVariant() {
    const json = this.querySelector("script[data-selected-variant]").textContent;
    this.currentVariant = !!json ? JSON.parse(json) : null;
  }

  /* ====== Get Source section id ====== */
  get sourceSectionId() {
    return this.dataset.originalSection || this.dataset.section;
  }
}
customElements.define("high-variant-selects", HighVariantSelects);
  

/* ====== Recommended products, complementary products ====== */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.fetchData();
      },
      { rootMargin: "0px 0px 400px 0px" },
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  fetchData() {
    webvista
      .fetchHtml(this.dataset.url)
      .then((html) => {
        this.renderHtml(html);
      })
      .catch((error) => {
        webvista.popToast(
          window["accessibilityStrings"]["unknownError"],
          "error",
        );
      });
  }

  renderHtml(html) {
    const sourceRecommendationMain = html.querySelector(`#${this.id} .recommendation-main`);
    if (sourceRecommendationMain) {
      this.querySelector(".products-container").innerHTML = sourceRecommendationMain.outerHTML;
    } else {
      this.remove();
    }
    // Load complete state
    webvista.initLazyImages();
    webvista.initTooltips();
  }
}
customElements.define("product-recommendations", ProductRecommendations);

/* ====== Product card handler class :: Primarily handles swatch image switching ====== */
class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.colorSwatches = this.querySelector(".color-swatches");
    if (this.colorSwatches) this.initSwatchHandle();
  }

  /* ====== Initialize the color picker ====== */
  initSwatchHandle() {
    this.colorSwatches.querySelectorAll(".color-swatch").forEach((swatch) => {
      swatch.addEventListener("click", this.onSwatchClick.bind(this));
    });
  }

  onSwatchClick(event) {
    event.stopPropagation();

    const swatch = event.currentTarget;
    const currentSwatch = this.colorSwatches.querySelector(".color-swatch.active");
    const index = swatch.getAttribute("data-index");

    const variantImage = this.querySelector(`.product-card-variant-image[data-index="${index}"]`);
    if (!variantImage) return;

    if (currentSwatch) this.inActiveSwatch(currentSwatch);
    if (swatch !== currentSwatch) this.activeSwatch(swatch, variantImage);
  }

  /* ====== Activate swatch ====== */
  activeSwatch(swatch, image) {
    swatch.classList.add("active");
    this.classList.add("has-swatch-active");
    image.classList.remove("hidden");
  }

  /* ====== Deactivate Swatch ====== */
  inActiveSwatch(swatch) {
    swatch.classList.remove("active");
    this.classList.remove("has-swatch-active");
    this.querySelector(`.product-card-variant-image[data-index="${swatch.getAttribute("data-index")}"]`)?.classList.add("hidden");
  }
}
customElements.define("product-card", ProductCard);

/* ====== Text container with height-limiting functionality. ====== */
class ExpandableContainer extends HTMLElement {
  constructor() {
    super();

    if (!this.hasAttribute("data-limit-height")) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.init();
          this.observer.disconnect();
        }
      },
      {
        rootMargin: "-300px 0px -300px 0px",
      },
    );
    this.observer.observe(this);
  }

  init() {
    if (this.contentMain.scrollHeight <= this.contentMain.clientHeight) return;

    this.classList.add("has-exceed");
    this.expandButton?.addEventListener("click", this.toggleExpand.bind(this));
    this.expandButton?.addEventListener("keydown", this.onKeyDown.bind(this));
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  get contentMain() {
    return this.querySelector(".content-main");
  }

  get expandButton() {
    return this.querySelector(".expand-button");
  }

  get readMoreText() {
    return this.querySelector(".read-more-text");
  }

  get readLessText() {
    return this.querySelector(".read-less-text");
  }

  toggleExpand() {
    const isExpanded = this.classList.toggle("has-expand");
    this.expandButton.setAttribute("aria-expanded", isExpanded.toString());
    // Provide feedback for screen readers
    if (isExpanded) {
      this.readMoreText.classList.add("hidden");
      this.readLessText.classList.remove("hidden");
    } else {
      this.readMoreText.classList.remove("hidden");
      this.readLessText.classList.add("hidden");
    }
  }

  onKeyDown(event) {
    // Handle Enter or Space key (standard for button activation)
    if (["Space", "Enter"].includes(event.code)) {
      event.preventDefault(); // Prevent scroll when Space is pressed
      this.toggleExpand();
    }
  }
}
customElements.define("expandable-container", ExpandableContainer);

// Focus the search input immediately when the search icon is clicked
$('.header-icon--search').on('click', function () {
  let $input = $('#Search-Drawer-Input');
  if ($input.length) {
    $input.focus();
  }
});

/* ====== Update Prices Dynamically for COMPARE-AT, SALE, VVIP & VVIP ====== */

/* ====== Update the visible price bucket (regular / compare-at / sale / vip / vvip)
 * for a SINGLE .price element. This is the fast, scoped path used on
 * variant change — it does not touch any other .price block on the page. ====== */
window.updateSinglePriceElement = function (el) {
  var $priceWrapper = $(el);

  var customId = parseFloat(
    $priceWrapper.find("[class*='regular-price-']")?.attr("class")?.match(/\d+/)?.[0]
  ) || 0;

  var compareAtPrice = parseFloat(el.getAttribute("data-compare")) || 0;
  var regularPrice   = parseFloat(el.getAttribute("data-regular")) || 0;
  var salePrice      = parseFloat(el.getAttribute("data-sale")) || 0;
  var vipSalePrice   = parseFloat(el.getAttribute("data-vip")) || 0;
  var vvipSalePrice  = parseFloat(el.getAttribute("data-vvip")) || 0;

  var showSalePrice = el.getAttribute("data-enable-sale") === "true";
  var showVipPrice  = el.getAttribute("data-enable-vip") === "true";
  var showVvipPrice = el.getAttribute("data-enable-vvip") === "true";

  var saleCode     = localStorage.getItem("sale_type") || "";
  var vipSaleCode  = el.getAttribute("data-vip-code") || "";
  var vvipSaleCode = el.getAttribute("data-vvip-code") || "";

  var $compare = $priceWrapper.find(".compare-at-price-" + customId);
  var $regular = $priceWrapper.find(".regular-price-" + customId);
  var $sale    = $priceWrapper.find(".rc-sale-price-" + customId);
  var $vip     = $priceWrapper.find(".rc-vip-price-" + customId);
  var $vvip    = $priceWrapper.find(".rc-vvip-price-" + customId);

  $compare.addClass("is-hide");
  $sale.addClass("is-hide");
  $vip.addClass("is-hide");
  $vvip.addClass("is-hide");
  $regular.removeClass("is-hide");

  if (compareAtPrice !== 0 && compareAtPrice > regularPrice) {
    $regular.addClass("is-hide");
    $compare.removeClass("is-hide");
  } else if (salePrice !== 0 && salePrice < regularPrice && showSalePrice) {
    $regular.addClass("is-hide");
    $sale.removeClass("is-hide");
  } else if (vipSalePrice !== 0 && vipSalePrice < regularPrice && showVipPrice && saleCode === vipSaleCode) {
    $regular.addClass("is-hide");
    $vip.removeClass("is-hide");
  } else if (vvipSalePrice !== 0 && vvipSalePrice < regularPrice && showVvipPrice && saleCode === vvipSaleCode) {
    $regular.addClass("is-hide");
    $vvip.removeClass("is-hide");
  }
};

/* ====== Page-wide pass — scans every .price element on the page. Kept for initial
 * page load and full section re-renders, but NO LONGER called on variant
 * change (that full sweep was the source of the 600-800ms delay: it was
 * re-scanning every recommendation/upsell price block on every click). ====== */
window.initDynamicPrices = function () {
  $(".price").each(function () {
    window.updateSinglePriceElement(this);
  });
};

/* ===== On Variant Change: Update Final Sale Check & Gift Wrap Check ===== */
webvista.subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
  const { sectionId, html, variant } = data;

  /* === Bespoke CTAs — update on both instant and full passes === */
  if (variant) {
    const cta = document.getElementById('js-bespoke-select-setting');
    if (cta) {
      cta.dataset.shape = variant.option1;
      cta.dataset.variant = variant.id;
      cta.dataset.price = variant.price;
    }

    const reviewDesignCta = document.getElementById('js-bespoke-review-your-design');
    if (reviewDesignCta) {
      reviewDesignCta.dataset.shape = variant.option1;
      reviewDesignCta.dataset.variant = variant.id;
      reviewDesignCta.dataset.price = variant.price;
    }
  }

  // Final Sale / Gift Wrap blocks need server HTML — skip on the instant pass
  if (!html) return;

  const sourceMsg = html.getElementById(`FinalSaleMsg-${sectionId}`);
  const targetMsg = document.getElementById(`FinalSaleMsg-${sectionId}`);
  /* === Add Gift Wrap Property === */
  const sourceMsgGiftWrap = html.getElementById(`GiftWrapMsg-${sectionId}`);
  const targetMsgGiftWrap = document.getElementById(`GiftWrapMsg-${sectionId}`);

  /* === Grab and update Final Sale flag: On Change === */
  if (!sourceMsg || !targetMsg) return;
  targetMsg.innerHTML = sourceMsg.innerHTML;
  targetMsg.className = sourceMsg.className;
  // Show only when variant is available (not sold out)
  const isAvailable = sourceMsg.dataset.available === "true";
  targetMsg.hidden = !isAvailable;

  /* === Grab and update Gift Wrap flag: On Change === */
  if (!sourceMsgGiftWrap || !targetMsgGiftWrap) return;
  targetMsgGiftWrap.dataset.giftWrap = sourceMsgGiftWrap.dataset.giftWrap;
});

/* ===== SHOW: SITE LOADER ===== */
function showLoader() {
  $('#siteLoaderInit').css('display', 'flex');
}

/* ===== HIDE: SITE LOADER ===== */
function hideLoader() {
  $('#siteLoaderInit').fadeOut(150);
}

/* ===== CLEAR BESPOKE LOCALSTORAGE DATA ===== */
function clearBespokeSelectedData() {
  localStorage.removeItem('rc_selected_diamond');
  localStorage.removeItem('selected-diamond-shopify-data');
  localStorage.removeItem('rc_selected_setting');
  localStorage.removeItem('_vow_item_cart')
}

/* ========= POPUP: CLOSE ========= */
document.getElementById('rc-generic-popup-close')?.addEventListener('click', function () {
  const cert = localStorage.getItem('_clicked_button_cert_id');
  if (cert) {
    const $prevBtn = $(`.rc-bespoke-select-diamond-btn[data-cert="${cert}"]`);
    $prevBtn.text('SELECT THIS DIAMOND').removeClass('selected').prop('disabled', false);
    $prevBtn.siblings('.rc-bespoke-remove-diamond-btn').addClass('hidden');
    localStorage.removeItem('_clicked_button_cert_id');
  }
  $('#rc-generic-popup').removeClass('open');
});

if (window.location.pathname === "/pages/swym-wishlist") {
  document.addEventListener("click", function (e) {
      const btn = e.target.closest(".swym-empty-wishlist-continue-btn");
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = "/collections/fine-jewelry";
    },
    true
  );
}